import { render, staticRenderFns } from "./FormulaResourceForm.vue?vue&type=template&id=21dda2f6"
import script from "./FormulaResourceForm.vue?vue&type=script&lang=js"
export * from "./FormulaResourceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports